import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import RedirectHelper from '../../utils/RedirectHelper';

const BasePage: React.FC<BasePageProps> = () => {
  const navigate = useNavigate();
  const redirectHelper = useMemo(() => new RedirectHelper(), []);

  useEffect(() => {
    if (redirectHelper.shouldRedirectToManagement()) {
      redirectHelper.redirectToManagement();
    }
    navigate('/home');
  }, [navigate, redirectHelper]);

  return <></>;
};

interface BasePageProps {}

export default BasePage;
